import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteTransportFileActions } from "store/ducks/transport-files";

export function* deleteTransportFileRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.delete,
      `/transport-files/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteTransportFileActions.success(data));
    notify("success", "Documento deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteTransportFileActions.failure(errorMessage));
  }
}
